module.exports = __webpack_public_path__ + "static/media/data-background.bf539716.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/data-background.png
// module id = 1818
// module chunks = 0